export const arrMatrix1 = [
{
       name: 'Илон',
       icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
       matrix: [
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
      ],
    },
    {
      name: 'Клава',
      icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
      matrix: [
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 0 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
      ],
    },
    {
      name: 'Семен',
      icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
      active: false,
      matched: true,
      id: 6,
      matrix: [
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 1, icon: 10 },
        { val: 0 },
      ],
    },
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
    {
      name: 'Толя',
      me: true,
      icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
      author: 5,
      matrix: [
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
        { val: 0 },
        { val: 1, icon: 10 },
      {
        val: 1,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
        { val: 1, icon: 10 },
      ],
    },
]

export const arrMatrix2 = [
  {
    name: 'Илон',
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Клава',
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    active: false,
    matched: true,
    id: 6,
    matrix: [
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },

  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    author: 0,
    matrix: [
      {
        val: 0,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
      { val: 1, icon: 'heart' },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },
]

export const arrMatrix3 = [
  {
    name: 'Илон',
    icon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Клава',
    icon: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Семен',
    icon: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
    active: false,
    matched: true,
    id: 6,
    matrix: [
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
    ],
  },
  {
    name: 'Егор',
    icon: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
    active: false,
    id: 6,
    matrix: [
      { val: 0 },
      { val: 0 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 0 },
    ],
  },
  {
    name: 'Толя',
    me: true,
    icon: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
    author: 0,
    matrix: [
      {
        val: 1,
        icon: 'help',
        question: true,
        answer: null,
        activate: false,
      },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
      { val: 1, icon: 10 },
      { val: 1, icon: 10 },
      { val: 0 },
    ],
  },
]

// export const arrPopup0 = [
//   { text: 'Задание: Проанализировать таблицу и определить, можно ли рекомендовать неизвестные мелодии Толе.', buttonTitle: 'Начать' },
// ]
export const arrPopup1 = [
  { text: 'Как ты думаешь, чей теперь профиль максимально похож на Толин?', buttonTitle: 'Начать' },
]
export const arrPopupChooseUser = [
  { text: 'Точность рекомендации теперь ниже, но это лучше, чем просто угадывать. Опираясь на данные похожего профиля, стал бы ты рекомендовать Толе песню Юли?', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Задание: найди чей профиль максимально похож на Толин?' },
]

export const task2 = [
  { text: 'Задание: теперь скажи, стоит ли рекомендовать Толе песню', key: 'task2' },
]

// export const arrPopup2 = [
//   { text: 'Согласен. Мне тоже кажется, чему понравится!!.' },
// ]
// export const arrPopup3 = [
//   { text: 'Согласен. Мне тоже кажется, что рекомендовать эту песню Толе не нужно.' },
// ]
// export const arrPopup4 = [
//   { text: 'пробуй еще' },
// ]
// export const arrPopupChooseUser = [
//   { text: 'Ого, у Егора точно такие же музыкальные интересы, как и у Толи! Теперь осталось сказать, стоит ли рекомендовать Толе песню Юли.', buttonTitle: 'Продолжить' },
// ]
// export const arrPopupChooseUserWrong = [
//   { text: 'Не уверен, что этот этот профиль похож на профиль Толи. Посмотри внимательнее.' },
// ]
